// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"131":"ShopEdit","186":"ShopAdd","443":"about","687":"ShopList"}[chunkId] || chunkId) + "-legacy." + {"131":"76c38cce","186":"c89e810b","443":"09f9f94a","491":"da00d97a","687":"f742697e"}[chunkId] + ".js";
};